import React from 'react';
import { Header } from 'layout';
import { UserAssetsTable } from 'modules';
import { AssetsColumnsType } from 'modules/UserAssetsTable/UserAssetsTable.columns';
import { useGetEtzProfileAssets } from 'hooks/api/portfolio';
import EtzProfileNavTabs from '../components/EtzProfileNavTabs';
import EtzProfileBalance from '../components/EtzProfileBalance';

import messages from './EtzProfileAssets.messages';

const etzProfileColumns: AssetsColumnsType[] = [
  'currency',
  'usdAmount',
  'cryptoAmount',
  'priceChange',
  'usdPrice',
];

const EtzProfileAssets: React.FC = () => {
  const {
    data: assetsData,
    isLoading: portfolioAssetsLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetEtzProfileAssets();

  return (
    <>
      <Header title={messages.headerTitle} />
      <EtzProfileNavTabs />
      <EtzProfileBalance />
      <UserAssetsTable
        columns={etzProfileColumns}
        assetsData={assetsData}
        portfolioAssetsLoading={portfolioAssetsLoading}
        isError={isError}
        refetch={refetch}
        isRefetching={isRefetching}
      />
    </>
  );
};

export default EtzProfileAssets;
